import styled from 'styled-components/macro'
import { ReactComponent as Logo } from '../../assets/Logo.svg'

import { noSelectDragCss } from '@anyonelab/common'

export const LogoStyled = styled(Logo)`
  ${noSelectDragCss}
`
